/**
 * @generated SignedSource<<170a6bece5f4182a5c95280953fd0926>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type presetConfigurationsQueriesDeleteCompositionMutation$variables = {
  deleteCompositionId: string;
};
export type presetConfigurationsQueriesDeleteCompositionMutation$data = {
  readonly deleteComposition: {
    readonly id: string;
  };
};
export type presetConfigurationsQueriesDeleteCompositionMutation = {
  response: presetConfigurationsQueriesDeleteCompositionMutation$data;
  variables: presetConfigurationsQueriesDeleteCompositionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deleteCompositionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "deleteCompositionId"
      }
    ],
    "concreteType": "Composition",
    "kind": "LinkedField",
    "name": "deleteComposition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesDeleteCompositionMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "presetConfigurationsQueriesDeleteCompositionMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "a2cd9da9fb1256a40e38af1b09f529d8",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesDeleteCompositionMutation",
    "operationKind": "mutation",
    "text": "mutation presetConfigurationsQueriesDeleteCompositionMutation(\n  $deleteCompositionId: ID!\n) {\n  deleteComposition(id: $deleteCompositionId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "268ea0227d71c88d794e81ab5602b41c";

export default node;
